import { action } from 'satcheljs';
export var removeDomain = action('removeDomain');
//# sourceMappingURL=removeDomain.js.map